import { render, staticRenderFns } from "./InvoiceSendTypeList.vue?vue&type=template&id=ffb25d4a&"
import script from "./InvoiceSendTypeList.vue?vue&type=script&lang=js&"
export * from "./InvoiceSendTypeList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceSendTypeList.vue?vue&type=style&index=0&id=ffb25d4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports